import React from 'react'
import { Text, View } from 'react-native'
import { WarfishClassicsHelp } from './WarfishClassicsHelp'
import { WARFISH_CLASSICS_CAPTION } from './presentation'

/** Legacy-only Map row. Desktop context belongs in its help, not the row. */
export function WarfishClassicsMapRow({ name }: { name: string }) {
  return <View testID="warfish-classics-map-row" className="py-2 border-b border-olive/30 gap-1">
    <View className="flex-row items-baseline gap-2">
      <Text className="font-typed text-ink-soft text-sm flex-1">Map</Text>
      <Text className="font-stencil text-ink text-sm">{name}</Text>
    </View>
    <View testID="warfish-classics-note" className="flex-row items-center justify-end gap-2">
      <Text className="font-typed text-ink-soft text-xs" style={{ textAlign: 'right', flexShrink: 1 }}>{WARFISH_CLASSICS_CAPTION}</Text>
      <WarfishClassicsHelp />
    </View>
  </View>
}
